import React, { useMemo, useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import styles from './Users.module.scss';

const TextWithOptionalTooltip = ({ textToHighlight, searchWords }) => {
  const [isHover, setIsHover] = useState(false);
  const myRef = useRef();

  const isEllipsis = useMemo(() => {
    const deviation = 5; // value in px
    return myRef.current?.scrollHeight - myRef.current?.offsetHeight > deviation;
  }, [textToHighlight, myRef.current?.scrollHeight]);

  return (
    <>
      <div ref={myRef} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        {textToHighlight ? (
          <Highlighter
            highlightClassName="wordHighlighter"
            className={styles.titleList}
            searchWords={searchWords}
            autoEscape
            textToHighlight={textToHighlight}
          />
        ) : (
          <span />
        )}
      </div>
      {isEllipsis && (
        <Tooltip text={textToHighlight} isHover={isHover} moveable={false} classNameTooltip={styles.tooltipContainer}>
          <Highlighter
            highlightClassName="wordHighlighter"
            className={styles.titleList}
            searchWords={searchWords}
            autoEscape
            textToHighlight={textToHighlight}
          />
        </Tooltip>
      )}
    </>
  );
};

export default TextWithOptionalTooltip;
